import { render } from "./CustomerAgreement.vue?vue&type=template&id=7c9d8ffb&scoped=true"
import script from "./CustomerAgreement.vue?vue&type=script&lang=js"
export * from "./CustomerAgreement.vue?vue&type=script&lang=js"

import "./CustomerAgreement.vue?vue&type=style&index=0&id=7c9d8ffb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9d8ffb"]])

export default __exports__